function initProductGalleryThumbnails() {
  const thumbnails = document.querySelectorAll('.product-gallery__thumbnail');
  thumbnails.forEach(function (thumbnail) {
    thumbnail.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const mediaId = this.getAttribute('data-media-id');
      document.querySelectorAll('.product-gallery__thumbnail').forEach(function (t) {
        t.classList.remove('is-nav-selected');
      });
      this.classList.add('is-nav-selected');
      document.querySelectorAll('.product-gallery__carousel-item').forEach(function (item) {
        item.classList.remove('is-selected');
      });
      const selectedItem = document.querySelector('.product-gallery__carousel-item[data-media-id="' + mediaId + '"]');
      if (selectedItem) {
        selectedItem.classList.add('is-selected');
        const carousel = document.querySelector('.product-gallery__carousel');
        const flickityViewport = carousel && carousel.querySelector('.flickity-viewport');
        if (flickityViewport) {
          flickityViewport.style.height = selectedItem.offsetHeight + 'px';
        }
      }
    });
  });
}

function initQuantityPriceUpdates() {
  const quantityInput = document.querySelector('input[name="quantity"]');
  const priceBox = document.getElementById('PriceList');

  if (!quantityInput || !priceBox) return;

  const priceSpan = priceBox.querySelector('.js-price');
  const compareSpan = priceBox.querySelector('.js-compare-price');

  if (!priceSpan || !compareSpan) return;

  const basePrice = parseFloat(priceBox.dataset.price);
  const baseCompare = parseFloat(priceBox.dataset.compare);

  function formatMoney(amount) {
    return `$${amount.toFixed(2)}`;
  }

  function updatePrices() {
    const qty = parseInt(quantityInput.value, 10) || 1;
    const totalPrice = basePrice * qty;
    const totalCompare = baseCompare * qty;

    priceSpan.textContent = formatMoney(totalPrice);

    if (compareSpan && baseCompare > basePrice) {
      compareSpan.textContent = formatMoney(totalCompare);
    }
  }

  quantityInput.addEventListener('input', updatePrices);

  const buttons = document.querySelectorAll(
    '[data-action="increase-picker-quantity"], [data-action="decrease-picker-quantity"]'
  );
  buttons.forEach((btn) => {
    btn.addEventListener('click', () => {
      setTimeout(updatePrices, 50);
    });
  });
}

function initExpandableContentToggle() {
  const button = document.querySelector('.expandable-content__toggle');
  if (!button) return;

  button.addEventListener('click', function () {
    const content = document.querySelector('.ui-accordion-content-active');
    if (content) {
      content.style.display = content.style.display === 'block' ? 'none' : 'block';
    }
  });
}

function initMobileStickyAtc() {
  const isMobile = window.matchMedia('(max-width: 630px)');

  if (!isMobile.matches) return;

  const sourceBlock = document.querySelector('.product-info__block-item--buy-buttons');
  if (!sourceBlock) return;

  const sourceButtons = sourceBlock.querySelector('.new-class') || sourceBlock;
  const mainAtcButton = sourceBlock.querySelector('[data-action="add-to-cart"]');

  if (!sourceButtons || !mainAtcButton) return;

  const stickyRoot = document.createElement('div');
  stickyRoot.className = 'mobile-sticky-atc';

  stickyRoot.innerHTML = '<div class="mobile-sticky-atc__inner"></div>';

  const stickyInner = stickyRoot.querySelector('.mobile-sticky-atc__inner');
  const clonedButtons = sourceButtons.cloneNode(true);
  let isAutoScrollingToSource = false;
  let scrollSafetyTimeoutId = null;

  clonedButtons.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));

  const updateStickyState = function (showSticky) {
    const isVisible = stickyRoot.classList.contains('is-visible');
    if (showSticky === isVisible) return;

    stickyRoot.classList.toggle('is-visible', showSticky);
  };

  const footerEl = document.querySelector('footer.footer') || document.querySelector('footer');

  const syncStickyStateWithViewport = function () {
    const sourceBottomPosition = sourceBlock.getBoundingClientRect().bottom + window.scrollY;
    const scrolledPastSource = window.scrollY > sourceBottomPosition;

    // Hide sticky ATC when the footer enters the sticky bar area so bottom content stays visible
    let nearFooter = false;
    if (footerEl) {
      const stickyHeight = stickyRoot.offsetHeight || 150;
      nearFooter = footerEl.getBoundingClientRect().top < window.innerHeight - stickyHeight * 0.25;
    }

    updateStickyState(scrolledPastSource && !nearFooter);
  };

  const releaseAutoScrollLock = function () {
    isAutoScrollingToSource = false;
    scrollSafetyTimeoutId = null;
    syncStickyStateWithViewport();
  };

  const clonedAtcButton = clonedButtons.querySelector('[data-action="add-to-cart"]');
  const productForm = document.querySelector('form[action*="/cart/add"]');
  if (clonedAtcButton) {
    clonedAtcButton.type = 'button';
    clonedAtcButton.addEventListener('click', function (e) {
      e.preventDefault();
      if (isAutoScrollingToSource) return;

      isAutoScrollingToSource = true;
      updateStickyState(false);

      if (scrollSafetyTimeoutId) window.clearTimeout(scrollSafetyTimeoutId);
      scrollSafetyTimeoutId = window.setTimeout(releaseAutoScrollLock, 700);

      const bcpoElement = document.getElementById('bcpo');
      if (bcpoElement) {
        scrollToElementWithStickyOffset(bcpoElement);
        return;
      }

      setTimeout(function () {
        if (!productForm) return;
        const isValid = productForm.reportValidity();
        if (!isValid) return;
        productForm.submit();
      }, 500);
    });
  }

  stickyInner.appendChild(clonedButtons);
  document.body.appendChild(stickyRoot);

  let isSyncScheduled = false;
  const scheduleStickySync = function () {
    if (isSyncScheduled) return;
    isSyncScheduled = true;

    window.requestAnimationFrame(function () {
      isSyncScheduled = false;
      if (isAutoScrollingToSource) return;
      syncStickyStateWithViewport();
    });
  };

  window.addEventListener('scroll', scheduleStickySync, { passive: true });

  window.addEventListener('resize', () => {
    if (!isMobile.matches) {
      updateStickyState(false);
    } else {
      scheduleStickySync();
    }
  });

  scheduleStickySync();
}

function getStickyHeaderOffset() {
  const styles = getComputedStyle(document.documentElement);
  const announcementHeight = parseFloat(styles.getPropertyValue('--announcement-bar-height')) || 0;
  const headerHeight = parseFloat(styles.getPropertyValue('--header-height')) || 0;
  const extraGap = 16;

  return announcementHeight + headerHeight + extraGap;
}

function scrollToElementWithStickyOffset(element) {
  const top = element.getBoundingClientRect().top + window.scrollY - getStickyHeaderOffset();
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
}

function initPswpAddToCart() {
  const atcButton = document.querySelector('[data-pswp-add-to-cart]');
  if (!atcButton) return;

  atcButton.addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();

    const closeButton = document.querySelector('.pswp__button--close');
    if (closeButton) closeButton.click();

    const bcpoElement = document.getElementById('bcpo');
    if (bcpoElement) {
      window.setTimeout(function () {
        scrollToElementWithStickyOffset(bcpoElement);
      }, 100);
      return;
    }

    const mainAtcButton = document.querySelector(
      '.product-info__block-item--buy-buttons [data-action="add-to-cart"]'
    );
    if (!mainAtcButton || mainAtcButton.disabled) return;

    mainAtcButton.click();
  });
}


function initVoOptionViewer() {
  const root = document.querySelector('[data-vo-option-viewer]');
  const modal = document.querySelector('[data-vo-option-viewer-modal]');
  const content = document.querySelector('[data-vo-option-viewer-content]');
  const tabsEl = document.querySelector('[data-vo-option-viewer-tabs]');
  if (!root || !modal || !content || !tabsEl) return;

  const selectLabel = root.getAttribute('data-select-label') || 'Select';
  const selectedLabel = root.getAttribute('data-selected-label') || 'Selected';
  const emptyLabel = root.getAttribute('data-empty-label') || '';
  const viewAllLabel = root.getAttribute('data-view-all-label') || 'View all options';

  let bcpoElement = null;
  let bcpoObserver = null;
  let isOpen = false;
  let rebuildScheduled = false;
  let syncingTriggers = false;
  let activeGroupKey = null;
  let cachedGroups = [];

  const EXPAND_ICON =
    '<svg class="vo-option-viewer-trigger__icon" width="14" height="14" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M2 6V2h4M10 2h4v4M14 10v4h-4M6 14H2v-4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function isDisplayed(element) {
    if (!element) return false;
    return window.getComputedStyle(element).display !== 'none';
  }

  function formatPrice(raw) {
    if (raw === null || raw === undefined || raw === '') return '';
    const amount = Number(raw);
    if (!Number.isFinite(amount) || amount === 0) return '';
    return '+$' + amount.toFixed(2);
  }

  function extractBackgroundUrl(label) {
    if (!label) return null;
    const inline = label.getAttribute('style') || '';
    const inlineMatch = inline.match(/url\(['"]?(.*?)['"]?\)/i);
    if (inlineMatch && inlineMatch[1]) return inlineMatch[1];

    const computed = window.getComputedStyle(label).backgroundImage;
    if (!computed || computed === 'none') return null;
    const computedMatch = computed.match(/url\(["']?(.*?)["']?\)/i);
    return computedMatch ? computedMatch[1] : null;
  }

  function enlargeImageUrl(url) {
    if (!url) return null;
    try {
      const path = url.split('?')[0];
      const parts = path.split('/');
      const encoded = parts[parts.length - 1];
      if (!encoded) return url;

      const decoded = JSON.parse(atob(encoded));
      if (!decoded || !decoded.edits || !decoded.edits.resize) return url;

      decoded.edits.resize.width = Math.max(Number(decoded.edits.resize.width) || 200, 400);
      parts[parts.length - 1] = btoa(JSON.stringify(decoded));
      return parts.join('/');
    } catch (error) {
      return url;
    }
  }

  function getGroupKey(wrapper) {
    const titleEl = wrapper.querySelector('.bcpo-title');
    return (
      wrapper.getAttribute('data-unique') ||
      (titleEl && titleEl.id) ||
      (titleEl && titleEl.textContent.trim()) ||
      'group'
    );
  }

  function getGroupTitle(wrapper) {
    const titleEl = wrapper.querySelector('.bcpo-title');
    return titleEl ? titleEl.textContent.replace(/:\s*$/, '').trim() : '';
  }

  function getGroupLabelRow(wrapper) {
    return wrapper.querySelector('.bcpo-label') || wrapper;
  }

  function isImageGroupSelectable(wrapper) {
    if (!wrapper || !wrapper.classList.contains('bcpo-images')) return false;
    if (!isDisplayed(wrapper)) return false;

    const selector = wrapper.querySelector('.single-option-selector');
    if (!isDisplayed(selector)) return false;

    return Array.from(wrapper.querySelectorAll('input.bcpo-front-image-option')).some(function (radio) {
      return !radio.disabled;
    });
  }

  function collectVisibleGroups() {
    if (!bcpoElement) return [];

    return Array.from(bcpoElement.querySelectorAll('.selector-wrapper.bcpo-images'))
      .filter(isImageGroupSelectable)
      .map(function (wrapper) {
        const title = getGroupTitle(wrapper);
        const key = getGroupKey(wrapper);
        const options = Array.from(wrapper.querySelectorAll('input.bcpo-front-image-option'))
          .filter(function (radio) {
            return !radio.disabled;
          })
          .map(function (radio) {
            let label = wrapper.querySelector('label[for="' + radio.id + '"]');
            if (!label) {
              const parent = radio.closest('.bcpo-image-parent');
              label = parent ? parent.querySelector('label') : null;
            }
            const rawUrl = extractBackgroundUrl(label);
            return {
              id: radio.id,
              name: radio.value || '',
              checked: radio.checked,
              priceLabel: formatPrice(radio.getAttribute('data-price')),
              imageUrl: enlargeImageUrl(rawUrl) || rawUrl
            };
          });

        return { key: key, title: title, wrapper: wrapper, options: options };
      })
      .filter(function (group) {
        return group.options.length > 0;
      });
  }

  function findTriggerByKey(key) {
    return Array.from(bcpoElement.querySelectorAll('[data-vo-group-trigger]')).find(function (el) {
      return el.getAttribute('data-group-key') === key;
    });
  }

  function syncGroupTriggers() {
    if (!bcpoElement || syncingTriggers) return;

    syncingTriggers = true;
    if (bcpoObserver) bcpoObserver.disconnect();

    try {
      cachedGroups = collectVisibleGroups();

      const activeKeys = {};
      cachedGroups.forEach(function (group) {
        activeKeys[group.key] = true;
      });

      Array.from(bcpoElement.querySelectorAll('[data-vo-group-trigger]')).forEach(function (btn) {
        const key = btn.getAttribute('data-group-key');
        if (!activeKeys[key]) btn.remove();
      });

      cachedGroups.forEach(function (group) {
        let button = findTriggerByKey(group.key);
        const labelRow = getGroupLabelRow(group.wrapper);

        if (!button) {
          button = document.createElement('button');
          button.type = 'button';
          button.className = 'vo-option-viewer-trigger link link--accented';
          button.setAttribute('data-vo-group-trigger', '');
          button.setAttribute('data-action', 'open-modal');
          button.setAttribute('aria-controls', 'VoOptionViewerModal');
          button.setAttribute('data-group-key', group.key);
          button.innerHTML =
            '<span class="vo-option-viewer-trigger__label"></span>' + EXPAND_ICON;
        }

        const labelEl = button.querySelector('.vo-option-viewer-trigger__label');
        if (labelEl && labelEl.textContent !== viewAllLabel) {
          labelEl.textContent = viewAllLabel;
        }

        if (button.getAttribute('data-group-key') !== group.key) {
          button.setAttribute('data-group-key', group.key);
        }

        labelRow.classList.add('vo-option-viewer-label-row');
        if (button.parentElement !== labelRow) {
          labelRow.appendChild(button);
        }
      });
    } finally {
      if (bcpoObserver && bcpoElement) {
        bcpoObserver.observe(bcpoElement, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class', 'disabled', 'checked']
        });
      }
      // Clear after mutations are delivered so observer ignores our own writes
      window.setTimeout(function () {
        syncingTriggers = false;
      }, 0);
    }
  }

  function mutationsAreOnlyOurTriggers(mutations) {
    return mutations.every(function (mutation) {
      if (mutation.type === 'attributes') {
        const target = mutation.target;
        return Boolean(
          target.closest &&
            (target.closest('[data-vo-group-trigger]') || target.matches('[data-vo-group-trigger]'))
        );
      }

      const nodes = Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes));
      if (nodes.length === 0) return true;

      return nodes.every(function (node) {
        if (node.nodeType !== 1) return true;
        return (
          node.matches('[data-vo-group-trigger]') ||
          Boolean(node.querySelector && node.querySelector('[data-vo-group-trigger]')) ||
          Boolean(node.closest && node.closest('[data-vo-group-trigger]'))
        );
      });
    });
  }

  function renderTabs(groups) {
    if (groups.length === 0) {
      tabsEl.hidden = true;
      tabsEl.innerHTML = '';
      return;
    }

    // Always show the opened group's name; no cross-group switching
    tabsEl.hidden = false;
    tabsEl.innerHTML = groups
      .map(function (group) {
        return (
          '<button type="button" class="vo-option-viewer-tab is-active" role="tab" aria-selected="true" tabindex="-1" data-vo-option-tab data-group-key="' +
          escapeHtml(group.key) +
          '">' +
          escapeHtml(group.title || viewAllLabel) +
          '</button>'
        );
      })
      .join('');
  }

  function renderCards(group) {
    if (!group) {
      content.innerHTML =
        '<p class="vo-option-viewer-modal__empty">' + escapeHtml(emptyLabel) + '</p>';
      return;
    }

    content.innerHTML =
      '<div class="vo-option-viewer-group__grid" role="tabpanel">' +
      group.options
        .map(function (option) {
          const safeName = escapeHtml(option.name);
          const safeId = escapeHtml(option.id);
          const priceHtml = option.priceLabel
            ? '<span class="vo-option-viewer-card__price">' + escapeHtml(option.priceLabel) + '</span>'
            : '';
          const imageHtml = option.imageUrl
            ? '<img class="vo-option-viewer-card__image" src="' +
              escapeHtml(option.imageUrl) +
              '" alt="' +
              safeName +
              '" loading="lazy" width="400" height="400">'
            : '<div class="vo-option-viewer-card__image vo-option-viewer-card__image--placeholder" aria-hidden="true"></div>';

          return (
            '<article class="vo-option-viewer-card' +
            (option.checked ? ' is-selected' : '') +
            '" data-vo-option-card data-radio-id="' +
            safeId +
            '">' +
            '<div class="vo-option-viewer-card__media">' +
            imageHtml +
            '</div>' +
            '<div class="vo-option-viewer-card__body">' +
            '<div class="vo-option-viewer-card__meta">' +
            '<h4 class="vo-option-viewer-card__name">' +
            safeName +
            '</h4>' +
            priceHtml +
            '</div>' +
            '<button type="button" class="button button--primary vo-option-viewer-card__select" data-vo-select-option data-radio-id="' +
            safeId +
            '" aria-pressed="' +
            (option.checked ? 'true' : 'false') +
            '"' +
            (option.checked ? ' disabled' : '') +
            '>' +
            escapeHtml(option.checked ? selectedLabel : selectLabel) +
            '</button>' +
            '</div>' +
            '</article>'
          );
        })
        .join('') +
      '</div>';
  }

  function getActiveGroupOnly() {
    const allGroups = collectVisibleGroups();
    cachedGroups = allGroups;

    if (!activeGroupKey) return allGroups[0] || null;

    return (
      allGroups.find(function (group) {
        return group.key === activeGroupKey;
      }) || null
    );
  }

  function renderModal() {
    const activeGroup = getActiveGroupOnly();

    if (!activeGroup) {
      tabsEl.hidden = true;
      tabsEl.innerHTML = '';
      content.innerHTML =
        '<p class="vo-option-viewer-modal__empty">' + escapeHtml(emptyLabel) + '</p>';
      return;
    }

    activeGroupKey = activeGroup.key;
    renderTabs([activeGroup]);
    renderCards(activeGroup);
  }

  function syncSelectedCards() {
    if (!isOpen) return;

    content.querySelectorAll('[data-vo-option-card]').forEach(function (card) {
      const radioId = card.getAttribute('data-radio-id');
      const radio = radioId ? document.getElementById(radioId) : null;
      const isSelected = Boolean(radio && radio.checked);
      card.classList.toggle('is-selected', isSelected);

      const button = card.querySelector('[data-vo-select-option]');
      if (!button) return;

      if (isSelected) {
        button.textContent = selectedLabel;
        button.setAttribute('aria-pressed', 'true');
        button.disabled = true;
      } else {
        button.textContent = selectLabel;
        button.setAttribute('aria-pressed', 'false');
        button.disabled = false;
      }
    });
  }

  function scheduleRebuild() {
    if (rebuildScheduled) return;
    rebuildScheduled = true;

    window.requestAnimationFrame(function () {
      rebuildScheduled = false;
      syncGroupTriggers();
      if (isOpen) renderModal();
    });
  }

  function selectOption(radioId) {
    const radio = document.getElementById(radioId);
    if (!radio || radio.disabled) return;

    radio.click();
    syncSelectedCards();
    window.setTimeout(scheduleRebuild, 50);
  }

  function onModalOpen() {
    isOpen = true;
    if (!activeGroupKey && cachedGroups[0]) {
      activeGroupKey = cachedGroups[0].key;
    }
    renderModal();
  }

  function onModalClose() {
    isOpen = false;
  }

  document.addEventListener('click', function (event) {
    const groupTrigger = event.target.closest('[data-vo-group-trigger]');
    if (groupTrigger) {
      activeGroupKey = groupTrigger.getAttribute('data-group-key');
      window.setTimeout(function () {
        if (modal.getAttribute('aria-hidden') === 'false' || modal.open) {
          onModalOpen();
        }
      }, 0);
      return;
    }

    const tab = event.target.closest('[data-vo-option-tab]');
    if (tab && tabsEl.contains(tab)) {
      // Single-group modal: tab is label-only, not a switcher
      event.preventDefault();
      return;
    }

    const selectBtn = event.target.closest('[data-vo-select-option]');
    if (selectBtn && content.contains(selectBtn)) {
      event.preventDefault();
      selectOption(selectBtn.getAttribute('data-radio-id'));
    }
  });

  modal.addEventListener('transitionend', function (event) {
    if (event.target !== modal || event.propertyName !== 'visibility') return;

    if (modal.getAttribute('aria-hidden') === 'false') {
      onModalOpen();
    } else {
      onModalClose();
    }
  });

  modal.addEventListener('close', onModalClose);

  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  root.hidden = true;

  function attachBcpoListeners(element) {
    if (bcpoObserver) bcpoObserver.disconnect();

    element.addEventListener('change', function () {
      syncSelectedCards();
      scheduleRebuild();
    });

    bcpoObserver = new MutationObserver(function (mutations) {
      if (syncingTriggers) return;
      if (mutationsAreOnlyOurTriggers(mutations)) return;

      const liveBcpo = document.getElementById('bcpo');
      if (liveBcpo && liveBcpo !== bcpoElement) {
        bcpoElement = liveBcpo;
        attachBcpoListeners(liveBcpo);
        return;
      }

      scheduleRebuild();
    });

    bcpoObserver.observe(element, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'disabled', 'checked']
    });

    syncGroupTriggers();
  }

  function waitForBcpo() {
    const existing = document.getElementById('bcpo');
    if (existing) {
      bcpoElement = existing;
      attachBcpoListeners(existing);
    }

    const finder = new MutationObserver(function () {
      const found = document.getElementById('bcpo');
      if (!found || found === bcpoElement) return;

      bcpoElement = found;
      attachBcpoListeners(found);
    });

    finder.observe(document.body, { childList: true, subtree: true });

    window.setTimeout(syncGroupTriggers, 500);
    window.setTimeout(syncGroupTriggers, 1500);
    window.setTimeout(syncGroupTriggers, 3000);
  }

  waitForBcpo();
}

document.addEventListener('DOMContentLoaded', function () {
  initProductGalleryThumbnails();
  initQuantityPriceUpdates();
  initExpandableContentToggle();
  initMobileStickyAtc();
  initPswpAddToCart();
  initVoOptionViewer();
});
